export const formatMessage = (template, params = {}) => {
  if(typeof template !== "string") return console.error("템플릿이 문자 타입이 아님")

  return Object.entries(params).reduce(
    (str, [key, value]) => str.replaceAll(`{${key}}`, value),
    template
  )
}
